import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row form-haeder q-mb-lg" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "number q-mb-sm flex items-center justify-center" }
const _hoisted_4 = { class: "category-name" }

interface Props {
  list: Array<string>;
  page: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InputFormHeader',
  props: {
    list: {},
    page: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (category, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["col d-flex justify-center", [
        props.page >= index && 'font-weight-bold',
        props.page === index && 'checked',
        props.page < index && 'yet',
      ]])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(index + 1), 1)
          ]),
          _createElementVNode("p", _hoisted_4, _toDisplayString(category), 1)
        ])
      ], 2))
    }), 128))
  ]))
}
}

})